import Skeleton from "./Skeleton";

export default function InventoryDetailsSkeleton() {
  return (
    <div className="p-6 space-y-6">
      {/* Header */}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
        <div className="space-y-2 w-full max-w-sm">
          <Skeleton className="h-7 w-48" />
          <Skeleton className="h-4 w-64" />
        </div>

        <Skeleton className="h-9 w-20 rounded-md" />
      </div>

      {/* Alert / Expiry warnings (placeholder) */}
      <Skeleton className="h-6 w-64" />

      {/* Stat Cards */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        <Skeleton className="h-24 w-full rounded-xl" />
        <Skeleton className="h-24 w-full rounded-xl" />
        <Skeleton className="h-24 w-full rounded-xl" />
        <Skeleton className="h-24 w-full rounded-xl" />
      </div>

      {/* Chart Card */}
      <div className="border rounded-lg shadow-sm p-4 space-y-4">
        {/* Chart Header */}
        <div className="flex flex-wrap justify-between items-center gap-3">
          <Skeleton className="h-5 w-40" />
          <div className="flex gap-2">
            <Skeleton className="h-8 w-28 rounded-md" />
            <Skeleton className="h-8 w-28 rounded-md" />
          </div>
        </div>

        {/* Chart Area */}
        <Skeleton className="h-64 w-full rounded-md" />
      </div>

      {/* Transaction Table */}
      <div className="border rounded-lg shadow-sm p-4 space-y-4">
        <Skeleton className="h-5 w-48" />
        <Skeleton className="h-8 w-full" />
        <Skeleton className="h-8 w-full" />
        <Skeleton className="h-8 w-full" />
        <Skeleton className="h-8 w-full" />
      </div>
    </div>
  );
}
